import { ChatInputButtonStyled } from "../styled";
import ChatSettingsTooltip from "src/reusable/components/ChatSettingsTooltip";

type ChatInputButtonProps = {
  icon: React.ReactNode;
  text: string;
  selected: boolean;
  tooltip?: string;
  tooltipPlacement?: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const ChatInputButton = ({
  icon,
  text,
  selected,
  tooltip,
  tooltipPlacement,
  onClick,
}: ChatInputButtonProps) => {
  return (
    <ChatSettingsTooltip
      title={tooltip}
      // @ts-ignore
      placement={tooltipPlacement ? tooltipPlacement : "top"}
      enterDelay={200}
      arrow
    >
      <ChatInputButtonStyled
        startIcon={selected ? icon : null}
        selected={selected}
        onClick={onClick}
        size="small"
      >
        {selected ? text : icon}
      </ChatInputButtonStyled>
    </ChatSettingsTooltip>
  );
};

export default ChatInputButton;
